import * as action from './actions/creators';
import * as api from './education-api';
import * as auth from '../auth/auth-middleware';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';

const openArticleInWindow = (articleId, accessToken, newTabWindow) => (
  Object.assign(newTabWindow, {
    location: api.getArticleContentUrl(articleId, accessToken),
  })
);

export const getArticlesAfterRead = (articleId, articles, dispatch) => {
  if (!articles) {
    return null;
  }

  // article may be new in more than one reading list so badge may
  // decrease by more than 1.
  articles.forEach((article) => {
    if (article.articleId === articleId) {
      if (!article.wasReadByPatient) {
        dispatch(action.decrementReadCount());
      }
    }
  });

  return articles.map((article) => {
    if (article.articleId === articleId) {
      if (!article.wasReadByPatient) {
        return { ...article, wasReadByPatient: new Date().getTime() };
      }
    }
    return article;
  });
};

const openArticleWithAccessToken = (articleId, state, accessToken, newWin, dispatch, inline) => {
  if (inline) {
    dispatch(action.inlineArticleUrlLoaded(api.getArticleContentUrl(articleId, accessToken)));
  } else {
    openArticleInWindow(articleId, accessToken, newWin);
  }
};

export const educationArticleRequested = (articleId, newWin, inline) => (dispatch, storeState) =>
  dispatch(auth.getNewAccessTokenFromForcedRefresh())
    .then(
      (accessToken) =>
        api.putMarkArticleAsRead(articleId).then(
          () => {
            openArticleWithAccessToken(
              articleId,
              storeState().education,
              accessToken,
              newWin,
              dispatch,
              inline);

            dispatch(action.articleSelected(articleId));

            // Calling "getArticlesAfterRead" update the Badge state counter
            // which in turn makes the shouldComponentUpdate in the HomePage return true.
            dispatch(action.articlesLoaded(
              getArticlesAfterRead(articleId, storeState().education.educationArticles, dispatch))
            );
          }
        ),
      () => null
    );

export const loadArticles = (patientId, showArchived) => (dispatch) =>
  api.getEducationArticles(patientId, showArchived)
    .then(
      (response) => dispatch(action.articlesLoaded(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(MsgBarActions.showErrorMessage());
        dispatch(action.articlesLoadFailure(error.message));
      }
    );

export const unreadCount = (patientId) => (dispatch) =>
  api.getUnreadArticleCount(patientId)
    .then(
      (response) => dispatch(action.unreadCounted(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(action.unreadCountFailure(error.message));
      }
    );

export const archivedCount = (patientId) => (dispatch) =>
  api.getArchivedArticleCount(patientId)
    .then(
      (response) => dispatch(action.archivedCounted(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(action.archivedCountFailure(error.message));
      }
    );

export const loadViewPreference = () => (dispatch, getState) =>
  api.getViewPreference(getState().profile.user.userId)
    .then(
      (response) => dispatch(action.viewPreferenceRead(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        if (error.status !== 404) {
          dispatch(action.viewPreferenceReadFailure(error.message));
        }
      }
    );
export const putViewPreference = (value) => (dispatch, getState) =>
  api.setViewPreference(getState().profile.user.userId, value)
    .then(
      () => dispatch(action.viewPreferenceSet(value)),
      (axiosResponse) => {
        const error = axiosResponse.response; dispatch(action.viewPreferenceSetFailure(error.message));
      }
    );
